import {Injectable} from '@angular/core';
import {EventInfo} from '../../models/event-info';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Four51Service} from '../../four51.service';
import * as moment from 'moment-timezone';
import { ApiService } from 'src/app/api.service';

@Injectable({
  providedIn: 'root'
})
export class FacebookService {

  constructor(private four51Service: Four51Service, private apiService: ApiService) {}

  async refresh(variantToUpdate: any, eventInfo: EventInfo, updateJpeg: boolean = true, updatePdf: boolean = false) {
    const eventTimeZone = eventInfo.sessions[0].eventStartTime.timeZone;
    const eventDateMoment = moment(this.ngbDateToString(eventInfo.sessions[0].eventDate), 'YYYY-MM-DD');
    let eventDateText;
    if (eventInfo.sessions.length === 1 ) {
      eventDateText = eventDateMoment.format('dddd, MMMM D') + ', ' +
        eventInfo.sessions[0].eventStartTime.moment.tz(eventTimeZone).format('h:mm A');
    } else {
      eventDateText = 'The first Session is on ' + eventDateMoment.format('dddd, MMMM D') + ' at ' +
        eventInfo.sessions[0].eventStartTime.moment.tz(eventTimeZone).format('h:mm A');
    }
    const data = {
      topicId: eventInfo.topicId,
      byoSelectedTopicId: eventInfo.byoSelectedTopicId,
      sessions: eventInfo.sessions,
      type: eventInfo.type
    };
    let productInteropID;
    switch (eventInfo.type) {
      case 'yoch': {
        productInteropID = 'MDVIP-FacebookYOCH';
        break;
      }
      default: {
        productInteropID = 'MDVIP-Facebook';
        break;
      }
    }
    const variant: any = {
      ProductInteropID: productInteropID,
      Specs: {
        title: {
          Value: eventInfo.title
        },
        event_date_text: {
          Value: eventDateText
        },
        venue_name: {
          Value: eventInfo.venue_name
        },
        venue_address_1: {
          Value: eventInfo.venue_address_1
        },
        venue_address_2: {
          Value: eventInfo.venue_address_2
        },
        venue_city: {
          Value: eventInfo.venue_city
        },
        brief_description: {
          Value: eventInfo.brief_description
        },
        rsvp_phone: {
          Value: eventInfo.rsvp_phone
        },
        rsvp_message: {
          Value: eventInfo.rsvp_message
        },
        venueType: {
          Value: (eventInfo.venueType)
        },
        webinarUrl: {
          Value: eventInfo.webinarUrl
        },
        data: {
          Value: JSON.stringify(data)
        }
      }
    };
    if (variantToUpdate) {
      variant.id = variantToUpdate.id;
    }

    const templateData = {};
    for (var key in variant.Specs) {
      if (variant.Specs.hasOwnProperty(key)) {
        templateData[key] = variant.Specs[key].Value;
      }
    }
    const body = {
        templateUrl: 'https://mdvipsf.seprint.com/assets/pdf-gen/templates/facebook-v2.html',
        data: templateData
    };
    if (updateJpeg) {
      const jpegResponse = await this.apiService.getJpeg(body).toPromise();
      variant.PreviewUrl = jpegResponse.url;
    }
    if (updatePdf) {
      const pdfResponse = await this.apiService.getPdf(body).toPromise();
      variant.ProofUrl = pdfResponse.url;
      console.log('update pdf');
    }

    const response = await this.apiService.createVariant(variant).toPromise();
    // const response = await this.four51Service.createVariant(variant).toPromise();
    return response;
  }

  ngbDateToString(object: NgbDate) {
    return (object) ? object.year + '-' + object.month + '-' + object.day : '';
  }
}
